/**
 * Resolve a user id to a human-readable display name using a pre-loaded
 * user map (typically from `useUserMap`). Falls back to "User <id>" when
 * the user is unknown or has no name/login.
 */

interface UserNameLike {
  name?: string | null;
  loginname?: string | null;
}

export function resolveUserName(
  userId: number,
  userMap: Map<number, UserNameLike>,
): string {
  const user = userMap.get(userId);
  if (!user) return `User ${userId}`;
  return user.name || user.loginname || `User ${userId}`;
}
